import type oktaAuth from '../oktaAuth';

export const guardedOktaSignInWithRedirect = async (oktaAuthInstance: typeof oktaAuth) => {
    if (!oktaAuthInstance.isLoginRedirect()) {
        await oktaAuthInstance.signInWithRedirect();
    }
};
